(function () {
  function scopeFor(el) {
    return (
      el.closest('.cart-drawer__summary, .cart__ctas, form[action*="/cart"]') || document
    );
  }

  function wire(container) {
    if (!container) return;
    const box = container.querySelector('#CartTermsCheckbox');
    if (!box) return;
    const err = container.querySelector('#CartTermsError');
    const scope = scopeFor(container);

    const checkoutBtns = scope.querySelectorAll(
      'button[name="checkout"], input[name="checkout"], a[href$="/checkout"]'
    );
    const dynamicBlocks = scope.querySelectorAll(
      '.shopify-payment-button, shopify-payment-button, .dynamic-checkout, .additional-checkout-buttons'
    );

    function applyState() {
      const ok = box.checked;
      checkoutBtns.forEach((b) => {
        if (b.tagName === 'A') {
          b.setAttribute('aria-disabled', String(!ok));
          b.classList.toggle('is-disabled', !ok);
          b.style.pointerEvents = ok ? '' : 'none';
        } else {
          b.disabled = !ok;
        }
      });
      dynamicBlocks.forEach((w) => (w.style.display = ok ? '' : 'none'));
      if (err) err.hidden = ok;
      container.classList.toggle('not-accepted', !ok);
    }

    scope.querySelectorAll('form[action*="/cart"]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        if (!box.checked) {
          e.preventDefault();
          if (err) err.hidden = false;
          box.focus();
        }
      });
    });

    checkoutBtns.forEach((b) =>
      b.addEventListener('click', (e) => {
        if (!box.checked) {
          e.preventDefault();
          if (err) err.hidden = false;
          box.focus();
        }
      })
    );

    box.addEventListener('change', applyState);
    applyState();
  }

  function init() {
    document.querySelectorAll('.terms-agree').forEach(wire);
  }

  document.addEventListener('DOMContentLoaded', init);

  new MutationObserver(init).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
